if (typeof document === "undefined") return;
var createStylesheet = function(chunkId, fullhref, oldTag, resolve, reject) {
	var linkTag = document.createElement("link");

	linkTag.rel = "stylesheet";
	linkTag.type = "text/css";
	var onLinkComplete = function(event) {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && (event.type === 'load' ? 'missing' : event.type);
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	linkTag.href = fullhref;

	if (oldTag) {
		oldTag.parentNode.insertBefore(linkTag, oldTag.nextSibling);
	} else {
		document.head.appendChild(linkTag);
	}
	return linkTag;
};
var findStylesheet = function(href, fullhref) {
	var existingLinkTags = document.getElementsByTagName("link");
	for(var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}
	var existingStyleTags = document.getElementsByTagName("style");
	for(var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if(dataHref === href || dataHref === fullhref) return tag;
	}
};
var loadStylesheet = function(chunkId) {
	return new Promise(function(resolve, reject) {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if(findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, null, resolve, reject);
	});
}
// object to store loaded CSS chunks
var installedCssChunks = {
	"umi": 0
};

__webpack_require__.f.miniCss = function(chunkId, promises) {
	var cssChunks = {"src_umi_umi_ts":1,"layouts__ForgetPasswordLayout":1,"layouts__TextOnlyLayout":1,"p__dashboard__index":1,"p__label-manage__create":1,"p__label-manage__pending":1,"p__label-manage__rejected":1,"p__label-manage__wms-preorder":1,"p__label-manage__wms-in-progress":1,"p__label-manage__wms-shipped":1,"p__label-manage__to-download":1,"p__delivery-booking__edit":1,"p__track-trace__index":1,"p__admin-shipment__shipment-summary__all-shipments":1,"p__admin-shipment__delivery-booking__edit":1,"p__admin-shipment__shipment-tracking__index":1,"p__admin-service__courier-services__detail":1,"p__warehouses__gate-charge__index":1,"p__warehouses__warehouse-scan__index":1,"p__settings__courier-services__edit":1,"src_global_less":1,"p__product-manage__products__edit":1,"p__marketplace__order-fulfillment__platform-order":1,"p__marketplace__order-fulfillment__fulfillment-order":1,"p__marketplace__order-fulfillment__fulfillment-request":1,"p__marketplace__order-fulfillment__wms-pre-order":1,"p__marketplace__order-fulfillment__wms-pending-selection":1,"p__marketplace__order-fulfillment__wms-in-progress":1,"p__marketplace__order-fulfillment__ready-to-ship":1,"p__marketplace__order-fulfillment__shipped-order":1,"p__marketplace__order-fulfillment__rejected-label":1,"p__marketplace__order-fulfillment__detail":1,"p__inbound__edit":1,"p__delivery-note__index":1,"p__delivery-note__edit":1,"p__rma-order__edit":1,"p__warehouse-bill__edit":1,"p__wms__dashboard__index":1,"p__wms__inbound__edit":1,"p__wms__outbound__outbound-order__delivery-note":1,"p__wms__outbound__outbound-order__edit":1,"p__wms__outbound__outbound-order__non-amr-pick-order":1,"p__wms__rma-order__edit":1,"p__wms__admin__warehouses__edit":1,"p__wms__admin__company-wms-quotation__edit":1,"p__wms__admin__bill-manage__warehouse-bill__edit":1,"p__wms__admin__wms-cost-quotation__edit":1,"p__wms__admin__cost-manage__wms-cost-bill__edit":1,"p__wms__products__edit":1,"p__wms__profile__settings__index":1,"p__profile__settings__index":1,"p__admin-platform__marketplace__edit":1,"p__admin-platform__store__connected":1,"p__admin-hs-code__edit":1,"umi__plugin-layout__Layout":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = loadStylesheet(chunkId).then(function() {
			installedCssChunks[chunkId] = 0;
		}, function(e) {
			delete installedCssChunks[chunkId];
			throw e;
		}));
	}
};

var oldTags = [];
var newTags = [];
var applyHandler = function(options) {
	return { dispose: function() {
		for(var i = 0; i < oldTags.length; i++) {
			var oldTag = oldTags[i];
			if(oldTag.parentNode) oldTag.parentNode.removeChild(oldTag);
		}
		oldTags.length = 0;
	}, apply: function() {
		for(var i = 0; i < newTags.length; i++) newTags[i].rel = "stylesheet";
		newTags.length = 0;
	} };
}
__webpack_require__.hmrC.miniCss = function(chunkIds, removedChunks, removedModules, promises, applyHandlers, updatedModulesList) {
	applyHandlers.push(applyHandler);
	chunkIds.forEach(function(chunkId) {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		var oldTag = findStylesheet(href, fullhref);
		if(!oldTag) return;
		promises.push(new Promise(function(resolve, reject) {
			var tag = createStylesheet(chunkId, fullhref, oldTag, function() {
				tag.as = "style";
				tag.rel = "preload";
				resolve();
			}, reject);
			oldTags.push(oldTag);
			newTags.push(tag);
		}));
	});
}